import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';

import CategoryCard from './CategoryCard';
import { useCompanyAnalysisReport } from '../hooks/useCompanyAnalysisReport';
import { getCategoryIcon } from '../utils/iconMapping';

type Props = {
  fromUserId: string;
  toUserId: string;
};

const AccordionBusinessChallenges: React.FC<Props> = ({ fromUserId, toUserId }) => {
  const {
    analysisReport,
    loading: loadingAnalysis,
    error: analysisError,
  } = useCompanyAnalysisReport(toUserId);

  const isOwnProfile = fromUserId === toUserId;

  console.log('[AccordionBusinessChallenges] Company Analysis Report:', analysisReport);
  console.log('[AccordionBusinessChallenges] Analysis Loading:', loadingAnalysis);
  console.log('[AccordionBusinessChallenges] Analysis Error:', analysisError);

  if (analysisError) {
    return (
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6" fontWeight="bold">
            Desafios Empresariais
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" color="error">
            Erro ao carregar análise da empresa: {analysisError}
          </Typography>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="h6" fontWeight="bold">
            Desafios Empresariais
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {loadingAnalysis ? (
          <Box display="flex" alignItems="center" justifyContent="center" p={4}>
            <Typography variant="body2" color="text.secondary">
              Carregando análise da empresa...
            </Typography>
          </Box>
        ) : analysisReport && analysisReport.data && analysisReport.data.length > 0 ? (
          <Box display="flex" flexDirection="column" gap={2}>
            {analysisReport.data.map(category => (
              <Box key={category.uuid} width="100%">
                <CategoryCard
                  category={category}
                  icon={getCategoryIcon(category.name)}
                  analysisReport={analysisReport}
                />
              </Box>
            ))}
          </Box>
        ) : (
          <Box display="flex" alignItems="center" justifyContent="center" p={4}>
            <Typography variant="body2" color="text.secondary">
              Nenhuma análise disponível para esta empresa.
            </Typography>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionBusinessChallenges;
